import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseDiscreteSelectorComponent } from "../../base/discrete-selector/base-discrete-selector.component";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-collections-discrete-selector",
  templateUrl: "../../collections/collections-timeline.component.html",
  styleUrls: ["../../base/timeline/base-timeline.component.scss"],
  standalone: false,
})
export class CollectionsDiscreteSelectorComponent extends BaseDiscreteSelectorComponent {
  constructor(
    googleAnalyticsService: GoogleAnalyticsService,
    cdr: ChangeDetectorRef,
    flagService: FeatureFlagsService,
  ) {
    super(googleAnalyticsService, cdr, flagService);
  }
}
